import { Box, Icon, Text } from '@chakra-ui/react';
import { LuGitCompare } from 'react-icons/lu';

const AgentsEmptyState = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={6}
      py={12}
    >
      <Icon as={LuGitCompare} color="fg.subtle" size="2xl" />
      <Text fontSize={18} fontWeight="bold" color="fg">No agents yet</Text>
      <Text fontSize={14} fontWeight={400} color="fg.muted">
        Agents allow you to add specific capabilities to chatbots as reusable tools. Once agents are configured, you'll see them listed here.
      </Text>
    </Box>
  );
};

export default AgentsEmptyState;